export var hiDentalAddOnKind = ['HD', 'HDL'];
export var addOnNameMapping = {
    NKSFLEX: 'Flex',
    FLEX: 'Joker flex',
    KT: 'Sick pay',
    URZ: 'Travel',
    HD: 'Hi dental',
    HDL: 'Hi dental plus',
};
